import React from "react";
import { Flex, Text, Link } from "@jsq/ds/core";
import { Colors } from "@jsq/ds/styles";

const KYCTextComponent: React.FC = () => {
  return (
    <Flex
      flexDirection={"column"}
      gap={12}
      css={{
        backgroundColor: Colors.Informative200,
        borderRadius: "10px",
        padding: "8px 12px",
      }}
    >
      <Flex flexDirection={"row"} gap={20} justifyContent="space-between">
        <Text variant="strong-lg">Instructions</Text>
        <Link
          href="https://junipersquare.atlassian.net/wiki/spaces/JSW/pages/2680258566/Canopy+Compliance+Case+Instructions"
          icon="external-link"
          iconPosition="right"
          shouldOpenInNewTab
        >
          Full instructions
        </Link>
      </Flex>
      <Flex>
        <Text asSpan variant="regular-md">
          <Text variant="strong-md">Screening Only</Text>
          <ul>
            <li>Create a profile for the Investor and screen against Sanctions.</li>
            <li>
              Dismiss false positive hits using demographic information. Escalate true hits.
            </li>
          </ul>
          <Text variant="strong-md">KYC</Text>
          <ul>
            <li>Create profiles for Investor, Beneficial Owner(s), and Controller.</li>
            <li>Attach ID or formation document.</li>
            <li>Attach the Beneficial Owners and Controller verification form.</li>
            <li>Screen the Investor, Beneficial Owner(s), and Controller against Sanctions.</li>
            <li>
              Dismiss false positive hits using demographic information. Escalate true hits
            </li>
          </ul>
          <Text variant="strong-md">AML</Text>
          <ul>
            <li>
              Create profiles for Investor, Beneficial Owner(s), Controllers and Bank Account.
            </li>
            <li>
              Screen the Investor, Beneficial Owner(s), and Controllers against Sanctions, PEP,
              and adverse media.
            </li>
            <li>
              Dismiss false positive hits using demographic information. Escalate true hits.
            </li>
            <li>Calculate the overall risk rating by identifying the highest risk rating.</li>
            <li>Attach all documents for the Investor, Beneficial Owner(s) and Controllers.</li>
          </ul>
        </Text>
      </Flex>
    </Flex>
  );
};

export default KYCTextComponent;
